<div [formGroup]="form" fxLayout="column">
  <div class="flex-wrap">
    <mat-form-field redispatchProvideReadonly fxFlex subscriptSizing="dynamic">
      <redispatch-erzeugungsanlage-form-prefix matPrefix
        [feld]="Feld.FIELD_STEUERBARE_RESOURCE_ID">
      </redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Steuerbare Ressource ID</mat-label>
      <input formControlName="steuerbareResourceId"
        data-qa="steuerbareResourceId"
        [required]="isSteuerbareResourceIdRequired"
        matInput
        name="sr_steuerbareResourceId"/>
      @if (f.steuerbareResourceId.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Steuerbare Ressource ID ein.
        </mat-error>
      }
      @if (f.steuerbareResourceId.hasError('nullRequired')) {
        <mat-error>
          Die Steuerbare Ressource ID muss leer bleiben.
        </mat-error>
      }
      @if (f.steuerbareResourceId.hasError('pattern')) {
        <mat-error>
          Länge 11, nur Großbuchstaben (wenn vorhanden), startet mit C und endet auf einer Zahl.
        </mat-error>
      }
      @if (f.steuerbareResourceId.hasError('checkDigit')) {
        <mat-error>
          Die Prüfsumme für die Steuerbare Ressource ID ist nicht korrekt.
        </mat-error>
      }
      @if (f.steuerbareResourceId.hasError('steuerbareResourceIdConflict')) {
          <mat-error>
            Bei Anlagen mit gleicher SR-ID müssen die Steuerinformationen und die Netzzuordnung gleich sein. Bei gleichen Steuerinformationen muss die SR-ID und die Netzzuordnung gleich sein.
          </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly fxFlex subscriptSizing="dynamic">
      <redispatch-erzeugungsanlage-form-prefix matPrefix
        [feld]="Feld.FIELD_TECHNISCHE_RESOURCE_ID">
      </redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Technische Ressource ID</mat-label>
      <input formControlName="technischeResourceId"
        data-qa="technischeResourceId"
        [required]="isTechnischeResourceIdRequired"
        matInput
        name="tr_technischeResourceId">
      @if (f.technischeResourceId.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Technische Ressource ID ein.
        </mat-error>
      }
      @if (f.technischeResourceId.hasError('pattern')) {
        <mat-error>
          Länge 11, nur Großbuchstaben (wenn vorhanden), startet mit D und endet auf einer Zahl.
        </mat-error>
      }
      @if (f.technischeResourceId.hasError('checkDigit')) {
        <mat-error>
          Die Prüfsumme für die Technische Ressource ID ist nicht korrekt.
        </mat-error>
      }
      @if (f.technischeResourceId.hasError('technischeResourceIdNotUnique')) {
        <mat-error>
          Die Technische Ressource ID ist nicht eindeutig.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field redispatchProvideReadonly fxFlex subscriptSizing="dynamic">
      <redispatch-erzeugungsanlage-form-prefix matPrefix
        [feld]="Feld.FIELD_STEUERGRUPPE_ID">
      </redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Steuergruppe ID</mat-label>
      <input formControlName="steuergruppeId"
        data-qa="steuergruppeId"
        matInput
        name="tr_steuergruppeId">
      @if (f.steuergruppeId.hasError('required')) {
        <mat-error>
          Bitte geben Sie eine Steuergruppen ID ein.
        </mat-error>
      }
      @if (f.steuergruppeId.hasError('nullRequired')) {
        <mat-error>
          Die Steuergruppen ID muss leer bleiben.
        </mat-error>
      }
      @if (f.steuergruppeId.hasError('pattern')) {
        <mat-error>
          Länge 11, nur Großbuchstaben (wenn vorhanden), startet mit B und endet auf einer Zahl.
        </mat-error>
      }
      @if (f.steuergruppeId.hasError('checkDigit')) {
        <mat-error>
          Die Prüfsumme für die Steuergruppen ID ist nicht korrekt.
        </mat-error>
      }
      @if (f.steuergruppeId.hasError('steuergruppeIdNetzzuordnungNotValid')) {
        <mat-error>
          Bereits einer anderen Netzzuordnung zugewiesen.
        </mat-error>
      }
    </mat-form-field>
  </div>
</div>
